import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    templateUrl: './duration.component.html',
    standalone: false
})
export class InstallationDurationPluginComponent {
  public duration: any;
  public config: any;
  public editRoute = ['installation', 'duration', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.duration = this.config.Duration;
  }
}
PluginComponent.plugins['installationduration'] = InstallationDurationPluginComponent;
